import type {
  AlgoliaProduct,
  FilterSelectItem,
  JaneSearchState,
  ProductFilterKeys,
} from '@jane/search/types';

/**
 * @todo - Expand and move to shared-ecomm.
 * Currently the search state is flattened and the value lookup is done across filter keys, taking into account store labels.
 * See:
 *   - client/libs/monolith/shared/src/lib/components/productFilters/formatActiveFilters.tsx
 *   - client/libs/monolith/shared/src/lib/components/productFilters/productFiltersWrapper.tsx
 */
export const isFilterSelected = (
  searchState: JaneSearchState<AlgoliaProduct>,
  filterKey: ProductFilterKeys,
  filterItem: FilterSelectItem
): boolean => {
  if (
    [
      'category',
      'root_types',
      'brand',
      'available_weights',
      'applicable_special_ids',
      'feelings',
      'has_brand_discount',
      'compound_names',
    ].includes(filterKey)
  ) {
    const filters =
      searchState.filters?.[filterKey as keyof typeof searchState.filters] ??
      [];
    return filters
      .map((f) => f.toString())
      .includes(filterItem.value.toString());
  } else if (filterKey === 'aggregate_rating' || filterKey === 'bucket_price') {
    const filters = searchState.bucketFilters?.[filterKey] ?? [];
    return filters.includes(filterItem.value.toString());
  }

  return false;
};
